import styled, { css } from 'styled-components'
import media from 'styled-media-query'
import Container from 'components/Container'
import background from 'assets/images/projects/background.png'
import cubes from 'assets/images/cubes.png'
import mcubes from 'assets/images/cubes-mobile-projects.png'

export const SectionWrapper = styled.div`
  background-image: url(${background});
  background-size: cover;
`

export const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings.small} 0;
    position: relative;
    z-index: 1;
    min-height: 540px;

    ${media.lessThan('medium')`
      min-height: 950px;
    `}
  `}

  .item-enter {
    opacity: 0;
  }

  .item-enter-active {
    opacity: 1;
    transition: opacity 500ms ease-in;
  }

  .item-exit {
    opacity: 1;
  }

  .item-exit-active {
    opacity: 0;
    transition: opacity 0 ease-in;
  }
`

export const WrapperNavbar = styled(Container)`
  ${media.lessThan('medium')`
    padding-right: 0 !important;
  `}
`

export const ProjectsTitle = styled.div`
  position: relative;
  text-align: center;
  padding: 100px 0;

  ${media.lessThan('medium')`
     padding: 40px 24px 100px 0;
  `}

  &:before {
    content: '';
    position: absolute;
    top: 113px;
    background-image: url(${cubes});
    background-repeat: no-repeat;
    z-index: 1;
    width: 339px;
    height: 64px;

    ${({ locale }) =>
      locale == 'en'
        ? css`
            transform: translateX(103px);
          `
        : css`
            transform: translateX(110px);
          `}

    ${media.lessThan('medium')`
      background-image: url(${mcubes});
      height: 40px;
      top: 63px;

      ${({ locale }) =>
        locale == 'en'
          ? css`
              width: 130px;
              transform: translateX(85px);
            `
          : css`
              width: 130px;
              transform: translateX(90px);
            `}
    `};
  }
`

export const Title = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.primary.main};
    font-family: ${theme.font.familyTertiary};
    font-size: ${theme.font.sizes.title};
    text-align: center;
    font-size: ${theme.font.sizes.xxlarge};
    font-weight: ${theme.font.bold};
    line-height: 56px;
    letter-spacing: 0em;
    text-align: right;

    ${media.lessThan('medium')`
      font-size: ${theme.font.sizes.xlarge};
    `}
  `}
`

export const ProjectsWrapper = styled.div`
  ${({ theme }) => css`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 1fr 1fr;
    grid-template-columns: repeat(3, 1fr);
    -ms-grid-rows: 1fr 1fr;
    grid-template-rows: auto;
    grid-gap: ${theme.spacings.small} ${theme.spacings.xsmall};
    width: 100%;
    min-width: 0;
    padding: 20px 10px 30px 240px;

    ${media.lessThan('medium')`
      grid-template-columns: 1fr;
    `}
  `}
`

export const Nav = styled.div`
  ${({ theme }) => css`
    max-width: 960px;
    margin: 0 auto ${theme.spacings.xlarge};
  `}
`

export const Overflow = styled.div`
  overflow-x: auto;
  display: flex;
  justify-content: space-between;

  button {
    flex: 1 0 140px;
  }
`
export const ProjectsAtDesktop = styled.div`
  display: block;
  position: relative;

  ${media.lessThan('large')`
    display: none;
  `}
`

export const Text = styled.div`
  ${() => css`
    width: 250px;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 20px;
    z-index: 4;
    height: 100%;
    background-color: #f4f4f4;
    background-image: url(${background});

    ${media.lessThan('medium')`
      width: 90vw;
      height: auto;
    `}
  `}
`

export const TextTitle = styled.h2`
  ${({ theme }) => css`
    font-family: ${theme.font.familyTertiary};
    font-size: 40px;
    font-weight: 700;
    margin-bottom: 40px;
    position: relative;
    color: rgba(0, 0, 0, 0.7);

    &:before {
      content: '';
      position: absolute;
      bottom: -20px;
      width: 70px;
      height: 4px;
      background-color: #ecb11f;
    }
  `}
`

export const TextDescription = styled.p`
  line-height: 1.4;
`

export const ProjectsAtMobile = styled.div`
  display: none;

  ${media.lessThan('large')`
    display: block;
    margin-top: 450px;
  `}
`

const navItemModifiers = {
  active: (theme) => css`
    border-bottom-color: ${theme.colors.primary.main};
    color: ${theme.colors.primary.main};
  `,
}

export const NavItem = styled.button`
  ${({ theme, active }) => css`
    border-bottom: 4px solid rgba(0, 0, 0, 0.2);
    color: gray;
    cursor: pointer;
    font-size: ${theme.font.sizes.large};
    font-family: ${theme.font.familyTertiary};
    font-weight: 600;
    line-height: 32px;
    text-align: center;
    padding-bottom: ${theme.spacings.xxsmall};
    transition: all 0.3s ease;
    outline: none;
    position: relative;

    &::after {
      background-color: ${theme.colors.primary.main};
      border-radius: 1px;
      border-radius: 1px;
      content: '';
      position: absolute;
      width: 0;
      height: 4px;
      left: 50%;
      top: 40px;
      transform: translateX(-50%);
      transition: width 0.25s ease, color 0.25s ease;
    }

    &:hover,
    &:focus {
      color: ${theme.colors.primary.main};
      &::after {
        width: 100%;
      }
    }

    ${media.lessThan('medium')`
      font-size: ${theme.font.sizes.medium};
    `}

    ${active && navItemModifiers.active(theme)};
  `}
`
